export default {
  TableHead: [
    [
      {
        displayName: 'report.onlineuser.datatable.number',
      },
      {
        displayName: 'report.onlineuser.datatable.game',
      },
      {
        displayName: 'Product',
      },
      {
        displayName: 'Coin',
      },
      {
        displayName: 'Cash',
      },
      {
        displayName: 'Total',
      },
    ],
  ],
};
